<template>
	<div class="flex xs-12 xs-between xs-middle">
		<div class="flex xs-middle xs">
			<input
				id="checkbox"
				v-if="!isTicked"
				type="checkbox"
				class="mr2"
				@change="$emit('update:checkbox', true)"
			/>

			<input
				id="checkbox"
				v-if="isTicked"
				type="checkbox"
				class="mr2"
				@change="$emit('update:checkbox', false)"
				checked
			/>

			<!-- Label/Inactive State -->
			<div
				v-if="isEditing === false && !isTicked"
				class="fs4 cu2"
				@click="showTextEditor"
			>{{ value }}</div>
			<strike
				v-if="isEditing === false && isTicked"
				class="fs4 c6 cu2"
				@click="showTextEditor"
			>{{ value }}</strike>

			<!-- Text Editor -->
			<j-base-input-long-text
				v-if="isEditing === true"
				size="xsmall"
				:rows="3"
				v-model="labelText"
				@blur="handleUpdateLabel"
				v-focus
			/>
		</div>

		<crm-icon
			name="delete"
			size="small"
			color="cError"
			class="cu2"
			@click.native="$emit('delete:item')"
		/>
	</div>
</template>

<script>
import JBaseInputLongText from "@/components/JBaseInputLongText/"
import CrmIcon from "@/components/CrmIcon/"

export default {
	components: {
		JBaseInputLongText,
		CrmIcon
	},

	props: {
		value: {
			type: String
		},

		isTicked: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			isEditing: false,
			labelText: null
		}
	},

	methods: {
		showTextEditor() {
			this.isEditing = true
		},
		hideTextEditor() {
			this.isEditing = false
		},
		handleUpdateLabel() {
			this.$emit("update:label", this.labelText)
			this.hideTextEditor()
		}
	},

	directives: {
		// auto focus on JBaseInputLongText
		focus: {
			inserted: function(el) {
				el.focus()
			}
		}
	},

	watch: {
		value: {
			handler() {
				this.labelText = this.value
			},
			immediate: true,
			deep: true
		}
	}
}
</script>

<style lang="css" scoped>
#checkbox {
	width: 15px;
	height: 15px;
}
</style>
